var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.5781 0.421875C23.2969 0.1875 22.9219 0 22.5 0H16.5C15.7031 0 15 0.65625 15 1.5C15 2.34375 15.7031 3 16.5 3H18.8906L8.25 13.6406C7.6875 14.2031 7.6875 15.1406 8.25 15.75C8.85938 16.3594 9.79688 16.3594 10.4062 15.75L21 5.10938V7.5C21 8.34375 21.7031 9 22.5 9C23.3438 9 24 8.34375 24 7.5V1.5C24 1.07812 23.8594 0.703125 23.5781 0.421875Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 15H17.25C16.8281 15 16.5 15.3281 16.5 15.75V21H3V7.5H8.25C8.67188 7.5 9 7.17188 9 6.75V5.25C9 4.82812 8.67188 4.5 8.25 4.5H2.25C1.03125 4.5 0 5.53125 0 6.75V21.75C0 22.9688 1.03125 24 2.25 24H17.25C18.4688 24 19.5 22.9688 19.5 21.75V15.75C19.5 15.3281 19.1719 15 18.75 15Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.7433a10f82a158ee3777c604aa02ed46.svg";
export { ForwardRef as ReactComponent };